import type {DrawerFilterState} from '../hooks/useFilterDrawer';

// Each logical drawer criteria counts as one field. The created/updated date
// pairs (after + before) each count as a single field since they share one widget.
export function countActiveFilterFields(filters: DrawerFilterState): number {
	let count = 0;
	if (filters.status.length > 0) count += 1;
	if (filters.priority.length > 0) count += 1;
	if (filters.sla_status.length > 0) count += 1;
	if (filters.assignee_id.length > 0) count += 1;
	if (filters.label_id.length > 0) count += 1;
	if (filters.requester_id.length > 0) count += 1;
	if (filters.created_after || filters.created_before) count += 1;
	if (filters.updated_after || filters.updated_before) count += 1;
	return count;
}
